<template>
  <div style="width: 100%;">
    <div
      class="d-flex pa-0 py-4"
      style="width: 100%"
    >
      <v-switch
        v-model="innerAutoSave"
        class="hide-details ma-0 mr-2 ml-4 pa-0 pt-1"
        color="secondary"
        inset
      />
      <v-btn
        :disabled="saving"
        :loading="saving"
        class="savebutton-pc"
        color="secondary"
        elevation="0"
        height="30px"
        outlined
        width="150px"
      >
        自動保存　{{ autoSave ? 'ON' : 'OFF' }}
      </v-btn>
    </div>
    <p
      v-if="lastSaveTime!=null"
      class="savetime-pc "
    >
      <ListIcon
        :style="`color: ${accentColor};width:6px;height:7px`"
        class="mr-1"
      />
      <b>最終保存</b> {{ lastSaveTime|dayjs }}
    </p>

    <div class="mx-4">
      <v-btn
        block
        color="secondary"
        elevation="0"
        height="50"
        max-height="50"
        style="border-radius: 8px;font-size: 17px;font-weight: bold"
        @click="save()"
      >
        <v-spacer />
        　保存する
        <v-spacer />
        <v-img
          contain
          max-height="23px"
          max-width="30px"
          src="../assets/save.png"
        />
      </v-btn>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import ListIcon from "@/component/svg/ListIcon";
import dayjs from "dayjs";

export default {
  name: "SaveLayoutPc",
  components: {
    ListIcon,
  },
  filters: {
    dayjs: function (date) {
      return dayjs(date).format('YYYY/MM/DD HH:mm');
    }
  },
  props: ["lastSaveTime", "saving", "save", "autoSave"],
  data() {
    return {
      accentColor: null,
      backgroundColor: null,
    }
  },
  mounted() {
    this.accentColor = this.$vuetify.theme.themes.light.secondary
    this.backgroundColor = this.$vuetify.theme.dark ? 'black' :
        'white'
  },
  computed: {
    innerAutoSave: {
      get() {
        return this.$props.autoSave
      },
      set(value) {
        this.$emit('change', value)
      }
    },
    ...mapState({
      user: state => state.userModule.user,
      fontSize: state => state.userModule.user.writerFontSizeTypeKeyValue.size * 13,
      lineSpaceSize: state => state.userModule.user.writerLineSpaceTypeKeyValue.value,
    }),
  },
}
</script>

<style scoped>
.savebutton-pc {
  padding-top: 1px !important;
  border: solid 2px var(--v-secondary-base) !important;
  border-radius: 5px;
  background-color: var(--v-background2-base) !important;
  font-weight: bold !important;
  font-size: 13px !important;
  color: var(--v-textcolor-base) !important;
}

.savetime-pc {
  margin-left: 12px;
  font-size: 12px;
  color: var(--v-textcolor-base) !important;
}
</style>
